import { render, staticRenderFns } from "./ClienteRead.vue?vue&type=template&id=4084c436&"
import script from "./ClienteRead.vue?vue&type=script&lang=js&"
export * from "./ClienteRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports